module.exports = __webpack_public_path__ + "media/company.31f07ab6.mp4";